import { render, staticRenderFns } from "./banjixiangqing.vue?vue&type=template&id=dc142a2e&scoped=true&"
import script from "./banjixiangqing.js?vue&type=script&lang=js&"
export * from "./banjixiangqing.js?vue&type=script&lang=js&"
import style0 from "./banjixiangqing.vue?vue&type=style&index=0&id=dc142a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc142a2e",
  null
  
)

export default component.exports